<template>
  <div
    class="col-12 ps-3 pe-3 d-flex align-items-center justify-content-end theme-header"
  >
    <button @click="$router.go(-1)" class="btn-back"></button>

    <p class="m-auto heading">{{ formatTitle(this.displayHeading) }}</p>
    <button
      class="btn"
      type="button"
      data-bs-toggle=""
      data-bs-target=""
      aria-controls=""
      style="padding-right: 0; padding-left: 0"
    >
      <img
        src="/img/ui-theme/contact-icon-rev.svg"
        alt="Fullscreen"
        height="30"
      />
    </button>
  </div>
</template>

<script>
import global from "../global";
import { unslugify } from "unslugify";

export default {
  name: "TypeTopNav",
  props: ["heading", "routeBack"],
  setup() {
    const { theme } = global;
    let displayHeading = "";

    return {
      theme,
      displayHeading,
    };
  },
  methods: {
    formatTitle: function (title) {
      if (title == "A1") {
        return "A1 – (A) DA";
      } else if (title == "A1 Mirror") {
        return "A1 - (A) Mirror";
      } else if (title == "B1") {
        return "B1 – (A) DA";
      } else if (title == "C1") {
        return "C1 – (A) GIA";
      } else if (title == "A1 Gia") {
        return "A1 - (GIA)";
      }
      return title;
    },
  },
  created() {
    this.displayHeading = unslugify(this.heading);
  },
};
</script>
